import React from 'react'
import MeasurementForm from './MeasurementForm'

const EditMeasurement = () => {
    return (
        <>
            <MeasurementForm />
        </>
    )
}

export default EditMeasurement